
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/items/[id]",
      function () {
        return require("private-next-pages/items/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/items/[id]"])
      });
    }
  